import React from "react";
import {
  DocumentTextIcon,
  VideoCameraIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";
import MenuItemCard from "../../Components/MenuItemCard";

const MENU_ITEMS = [
  {
    id: "webinar",
    icon: VideoCameraIcon,
    titleKey: "Webinar",
    descriptionKey:
      "Learn the latest tax regulations and solutions directly presented by tax experts.",
    route: "/webinar",
  },
  {
    id: "tutoring",
    icon: UserGroupIcon,
    titleKey: "Tutoring Programs",
    descriptionKey: "Helping you understand and resolve tax issues.",
    route: "/tutoring",
  },
  {
    id: "materials",
    icon: DocumentTextIcon,
    titleKey: "Tax Materials",
    descriptionKey: "A collection of tax materials needed when handling taxes.",
    route: "/resource",
  },
];

const TaxLearningList = () => {
  return (
    <div className="max-w-5xl">
      <div className="grid grid-cols-6 gap-4 items-stretch">
        {MENU_ITEMS.map((item) => (
          <MenuItemCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default TaxLearningList;
